/* Top Interiors product page: gallery, variant picker, optional extras, quantity and add to basket. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ti-pdp]');
  if (!root || root.getAttribute('data-ti-ready')) return;
  root.setAttribute('data-ti-ready', '1');

  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var data = {};
  try { data = JSON.parse(root.querySelector('[data-ti-product-json]').textContent); } catch (e) { return; }
  var product = data.product;
  var variants = product.variants;
  var showCompare = !!data.showCompare;

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function money(cents) {
    var v = cents / 100;
    if (cents % 100 === 0) return '£' + v.toLocaleString('en-GB');
    return '£' + v.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  var stageImg = $('[data-ti-stage-img]');
  var thumbs = $$('[data-ti-thumb]');
  var current = 0;
  thumbs.forEach(function (t, k) { if (t.classList.contains('is-active')) current = k; });
  function show(i) {
    if (!thumbs.length || !stageImg) return;
    current = (i + thumbs.length) % thumbs.length;
    var t = thumbs[current];
    stageImg.src = t.getAttribute('data-src');
    stageImg.srcset = t.getAttribute('data-srcset') || '';
    stageImg.alt = t.getAttribute('data-alt') || '';
    thumbs.forEach(function (x, k) {
      x.classList.toggle('is-active', k === current);
      x.setAttribute('aria-current', k === current ? 'true' : 'false');
    });
  }
  thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
  var prev = $('[data-ti-prev]');
  var next = $('[data-ti-next]');
  if (prev) prev.addEventListener('click', function () { show(current - 1); });
  if (next) next.addEventListener('click', function () { show(current + 1); });
  var stage = $('[data-ti-stage]');
  if (stage) {
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }
  var zoomBtn = $('[data-ti-zoom]');
  var dialog = root.querySelector('[data-ti-lightbox]');
  if (zoomBtn && dialog && dialog.showModal) {
    zoomBtn.addEventListener('click', function () {
      var t = thumbs[current];
      var img = dialog.querySelector('img');
      img.src = t ? t.getAttribute('data-full') : stageImg.src;
      img.alt = stageImg ? stageImg.alt : '';
      dialog.showModal();
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('[data-ti-lightbox-close]')) dialog.close();
    });
  }
  function showMedia(mediaId) {
    if (!mediaId) return;
    for (var k = 0; k < thumbs.length; k++) {
      if (thumbs[k].getAttribute('data-media-id') === String(mediaId)) { show(k); return; }
    }
  }

  var fieldsets = $$('[data-ti-option]');
  var selected = (variants.filter(function (v) { return v.id === data.selectedId; })[0] || variants[0]).options.slice();

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function currentVariant() { return findVariant(selected); }

  function pick(index, value) {
    var cand = selected.slice();
    cand[index] = value;
    if (!findVariant(cand)) {
      var best = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options[index] !== value) continue;
        if (!best || (v.available && !best.available)) best = v;
        if (best.available) break;
      }
      if (best) cand = best.options.slice();
    }
    selected = cand;
    update(true);
  }

  fieldsets.forEach(function (fs) {
    var idx = Number(fs.getAttribute('data-index'));
    $$('[data-ti-value]', fs).forEach(function (btn) {
      btn.addEventListener('click', function () { pick(idx, btn.getAttribute('data-ti-value')); });
    });
  });

  function paintOptions() {
    fieldsets.forEach(function (fs) {
      var idx = Number(fs.getAttribute('data-index'));
      var label = $('[data-ti-selected-label]', fs);
      if (label) label.textContent = selected[idx];
      $$('[data-ti-value]', fs).forEach(function (btn) {
        var val = btn.getAttribute('data-ti-value');
        var on = val === selected[idx];
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var probe = selected.slice();
        probe[idx] = val;
        var v = findVariant(probe);
        btn.classList.toggle('is-unavailable', !v || !v.available);
        var sub = $('[data-ti-value-sub]', btn);
        if (sub) {
          if (!v) sub.textContent = 'Not in this combination';
          else if (!v.available) sub.textContent = 'Sold out';
          else sub.textContent = btn.hasAttribute('data-ti-show-price') ? money(v.price) : 'Available';
        }
      });
    });
  }

  var extrasEl = $('[data-ti-extras]');
  var groupsEl = $('[data-ti-extras-groups]');
  var extrasTotalEl = $('[data-ti-extras-total]');
  var groups = [];
  var state = [];
  var priceToVariant = {};

  function isNone(c) { return c.p === 0 && /^(none|no)$/i.test(c.l); }
  function extrasSum() {
    var s = 0;
    state.forEach(function (c) { if (c) s += c.p; });
    return s;
  }
  function renderExtras() {
    if (!groupsEl || !groups.length) return;
    var v = currentVariant();
    var ctx = {};
    (v ? v.options : selected).forEach(function (o) { ctx[o] = true; });
    groupsEl.innerHTML = '';
    groups.forEach(function (g, i) {
      var opts = g.c.filter(function (c) { return !c.w || c.w.some(function (x) { return ctx[x]; }); });
      if (!opts.length) { state[i] = null; return; }
      var cur = null;
      if (state[i]) cur = opts.filter(function (o) { return o.l === state[i].l && o.p === state[i].p; })[0] || null;
      if (!cur) cur = opts.filter(function (o) { return o.p === 0; })[0] || opts[0];
      state[i] = cur;
      ctx[cur.l] = true;
      var id = 'ti-extra-' + i;
      var wrap = document.createElement('div');
      wrap.className = 'ti-extras__group';
      var lab = document.createElement('label');
      lab.className = 'ti-opt__label';
      lab.htmlFor = id;
      lab.textContent = g.n;
      var sel = document.createElement('select');
      sel.id = id;
      sel.className = 'ti-select';
      opts.forEach(function (o, k) {
        var op = document.createElement('option');
        op.value = String(k);
        op.textContent = o.l + (o.p ? ' (+' + money(o.p * 100) + ')' : '');
        if (o === cur) op.selected = true;
        sel.appendChild(op);
      });
      sel.addEventListener('change', function () {
        state[i] = opts[Number(sel.value)];
        renderExtras();
        paintPrice();
      });
      wrap.appendChild(lab);
      wrap.appendChild(sel);
      groupsEl.appendChild(wrap);
    });
    var sum = extrasSum();
    if (extrasTotalEl) {
      extrasTotalEl.hidden = sum <= 0;
      extrasTotalEl.textContent = sum > 0 ? 'Extras selected: +' + money(sum * 100) + ' each. Added to your basket as separate lines.' : '';
    }
  }

  var qtyInput = $('[data-ti-qty]');
  function qty() { return Math.max(1, Math.min(99, Number(qtyInput && qtyInput.value) || 1)); }
  $$('[data-ti-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qtyInput) return;
      qtyInput.value = Math.max(1, Math.min(99, qty() + Number(b.getAttribute('data-ti-qty-step'))));
      paintPrice();
    });
  });
  if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); paintPrice(); });

  var atc = $('[data-ti-atc]');
  var atcLabel = $('[data-ti-atc-label]');
  var errEl = $('[data-ti-buy-error]');
  var idInput = $('[data-ti-variant-id]');

  function paintPrice() {
    var v = currentVariant();
    var priceEl = $('[data-ti-price]');
    var cmpEl = $('[data-ti-compare]');
    var saveEl = $('[data-ti-save]');
    var availEl = $('[data-ti-avail]');
    if (!v) {
      if (atc) atc.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Unavailable';
      if (availEl) { availEl.textContent = 'Unavailable'; availEl.classList.add('is-out'); }
      return;
    }
    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    var hasCmp = showCompare && v.compare_at_price && v.compare_at_price > v.price;
    if (cmpEl) { cmpEl.hidden = !hasCmp; cmpEl.textContent = hasCmp ? money(v.compare_at_price) : ''; }
    if (saveEl) {
      saveEl.hidden = !hasCmp;
      if (hasCmp) {
        var pct = Math.round((1 - v.price / v.compare_at_price) * 100);
        saveEl.textContent = 'Save ' + money(v.compare_at_price - v.price) + ' (' + pct + '% off)';
      }
    }
    if (availEl) {
      availEl.textContent = v.available ? 'Available to order' : 'Sold out';
      availEl.classList.toggle('is-out', !v.available);
    }
    var total = (v.price + extrasSum() * 100) * qty();
    if (atc) atc.disabled = !v.available;
    if (atcLabel) atcLabel.textContent = v.available ? 'Add to Basket · ' + money(total) : 'Sold out';
  }

  function update(fromUser) {
    paintOptions();
    var v = currentVariant();
    if (v && fromUser) {
      showMedia(v.featured_media_id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    renderExtras();
    paintPrice();
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
  }

  var form = $('[data-ti-buy-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = currentVariant();
      if (!v || !v.available) return;
      var q = qty();
      var props = {};
      var items = [];
      var missing = false;
      groups.forEach(function (g, i) {
        var c = state[i];
        if (!c || isNone(c)) return;
        props[g.n] = c.l + (c.p ? ' (+' + money(c.p * 100) + ')' : '');
        if (c.p > 0) {
          var optId = priceToVariant[c.p.toFixed(2)];
          if (!optId) { missing = true; return; }
          items.push({ id: optId, quantity: q, properties: { For: product.title, Extra: g.n + ': ' + c.l } });
        }
      });
      if (missing) {
        if (errEl) { errEl.hidden = false; errEl.textContent = 'Sorry, one of the selected extras is not available online. Please contact us to order it.'; }
        return;
      }
      items.unshift({ id: v.id, quantity: q, properties: props });
      atc.disabled = true;
      var old = atcLabel.textContent;
      atcLabel.textContent = 'Adding…';
      window.TI.addItems(items)
        .then(function () {
          window.TI.toast(product.title + ' added to your basket');
        })
        .catch(function (err) {
          if (errEl) { errEl.hidden = false; errEl.textContent = err.message || 'Sorry, this could not be added to your basket.'; }
        })
        .then(function () {
          atcLabel.textContent = old;
          paintPrice();
        });
    });
  }

  var share = $('[data-ti-share]');
  if (share) {
    share.addEventListener('click', function () {
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: product.title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var lbl = share.querySelector('[data-ti-share-label]');
          if (lbl) { lbl.textContent = 'Link copied'; setTimeout(function () { lbl.textContent = 'Share'; }, 2000); }
        });
      }
    });
  }

  update(false);
  var addonsUrl = root.getAttribute('data-addons-url');
  if (addonsUrl && extrasEl) {
    Promise.all([
      fetch(addonsUrl).then(function (r) { return r.ok ? r.json() : {}; }),
      fetch(shopRoot + 'products/furniture-option.js').then(function (r) { return r.ok ? r.json() : { variants: [] }; })
    ]).then(function (res) {
      groups = res[0][product.handle] || [];
      (res[1].variants || []).forEach(function (v) { priceToVariant[(v.price / 100).toFixed(2)] = v.id; });
      if (!groups.length) return;
      state = groups.map(function () { return null; });
      extrasEl.hidden = false;
      renderExtras();
      paintPrice();
    }).catch(function () {});
  }
})();
